import { render, staticRenderFns } from "./hubs.vue?vue&type=template&id=b059d528&"
import script from "./hubs.vue?vue&type=script&lang=js&"
export * from "./hubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports